import React from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';
import colors from '@front/common/src/utils/colors';
import * as URLS from '@front/common/src/constants/urls';

import { translate } from '@front/i18n';

import SimpleLink from '@front/web-ui/src/components/link/simple-link';
import Icon from '@front/web-ui/src/components/icon/icon';

const t = translate('basket');

const AllowanceLine = styled.div`
  margin-top: ${toRem(10)};
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const AllowanceLink = styled.span`
  margin-right: ${toRem(5)};
`;

const AllowanceInfo = () => (
  <AllowanceLine>
    <AllowanceLink>
      <SimpleLink title={t('.childcare.allowance.link_title')} openInNewTab href={URLS.ALLOWANCE_CAF}>
        {t('.childcare.allowance.info')}
      </SimpleLink>
    </AllowanceLink>
    <span>
      <Icon name='information' size={25} color={colors.ink100} />
    </span>
  </AllowanceLine>
);

export default AllowanceInfo;
